module.exports = __webpack_public_path__ + "catalog/items/stairs/stairs-with-turn/stairs-with-turn-icon.svg";